module.exports = __webpack_public_path__ + "static/media/io_unit_on.a6ba8a17.jpg";